import React from "react";
import "./index.css";

const DotLoaders = () => (
  <div className="d-flex vh-100 justify-content-center align-items-center">
    {[...Array(3)].map((_, i) => (
      <div
        key={i}
        className="spinner-grow spinner-grow-bed mx-2"
        // style={{ color: "#BED643" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    ))}
  </div>
);

export default DotLoaders;

